import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const GuestsSection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('memorial-language') || 'ar';
    setCurrentLanguage(savedLanguage);

    // Listen for language changes
    const handleLanguageChange = (event) => {
      const newLanguage = event.detail?.language || 'ar';
      setCurrentLanguage(newLanguage);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  const guestsContent = {
    ar: {
      title: "ضيوف يحملون الحكاية",
      subtitle: "تستضيف فعاليّة «عامٌ على النصر» عددًا من الشخصيّات السوريّة التي عاشت الثورة، وواكبت مسارها، وساهمت في توثيقها أو خدمتها كلٌّ من موقعه.",
      guests: [
        {
          id: 'saleh',
          name: 'صالح خطيب "أبو ماهر"',
          position: 'المنشد',
          image: '/assets/logos/munshid.jpg',
          isHonorGuest: true
        },
        {
          id: 'baraa',
          name: 'براء العويّد',
          position: 'المنشد',
          image: '/assets/logos/baraa.jpg',
          isHonorGuest: true
        },
        {
          id: 'halak',
          name: 'عبدالناصر حلاق',
          position: 'المنشد',
          image: '/assets/logos/halak.JPG',
          isHonorGuest: true
        },
        // {
        //   id: 'tamer',
        //   name: 'تامر تركماني',
        //   position: 'صاحب مشروع أرشيف الثورة السورية',
        //   image: '/assets/images/no_image.png',
        //   isHonorGuest: false
        // },
        // {
        //   id: 'osama',
        //   name: 'أسامة عثمان',
        //   position: 'رفيق ومساعد قيصر في توثيق انتهاكات المعتقلين',
        //   image: '/assets/images/no_image.png',
        //   isHonorGuest: false
        // }
      ],
      closingStatement: "فقرات الحفل تتكامل لتقدّم تجربة تعيد سرد الحكاية من جديد؛ من لحظة التحرير إلى الطريق المفتوح بعدها أمام السوريين.",
      seminarTitle: "ضيوف ندوة \"دور مجتمع الشتات في الإعمار\"",
      seminarGuests: [
        {
          id: 'mahdi',
          name: 'د. مهدي داوود',
          position: 'مدير اتحاد منظمات المجتمع المدني للتنمية',
          image: '/assets/logos/د. مهدي داوود.jpg',
          isHonorGuest: false
        },
        {
          id: 'kablan',
          name: 'د. عبدالكريم قبلان',
          position: 'الأمين العام - الاتحاد العام لطلبة سوريا',
          image: '/assets/logos/د. عبدالكريم قبلان.JPG',
          isHonorGuest: false
        },
        {
          id: 'ghassan',
          name: 'المحاور الصحفي غسان ياسين',
          position: 'مُحاور',
          image: '/assets/logos/yasin.jpeg',
          isHonorGuest: false
        },
        {
          id: 'musa_seminar',
          name: 'موسى العمر',
          position: 'صحفي',
          image: '/assets/logos/الصحفي موسى العمر.jpeg',
          isHonorGuest: false
        },
        {
          id: 'aktaa',
          name: 'أ. محمد أكتع',
          position: 'المدير العام لمنبر منظمات المجتمع المدني',
          image: '/assets/logos/أ. محمد أكتع.jpg',
          isHonorGuest: false
        }
      ]
    },
    en: {
      title: "Guests Who Carry the Story",
      subtitle: "The event 'A Year of Victory' hosts a number of Syrian personalities who lived the revolution, followed its path, and contributed to documenting or serving it, each from their position.",
      guests: [
        {
          id: 'saleh',
          name: 'Munshid Saleh Khatib "Abu Maher"',
          position: 'Singer/Reciter',
          image: '/assets/logos/منشد.png',
          isHonorGuest: true
        },
        {
          id: 'musa',
          name: 'Journalist Musa Al-Omar',
          position: 'Journalist',
          image: '/assets/logos/musa.jpg',
          isHonorGuest: true
        },
        {
          id: 'baraa',
          name: 'Munshid Baraa Al-Awad',
          position: 'Singer/Reciter',
          image: '/assets/logos/baraa.jpg',
          isHonorGuest: true
        },
        {
          id: 'halak',
          name: 'Munshid Abdul Nasser Halak',
          position: 'Singer/Reciter',
          image: '/assets/logos/halak.JPG',
          isHonorGuest: true
        }
      ],
      closingStatement: "The ceremony's segments come together to present an experience that retells the story anew; from the moment of liberation to the open path that followed for Syrians.",
      seminarTitle: "Guests of the Seminar \"The Role of the Diaspora Community in Reconstruction\"",
      seminarGuests: [
        {
          id: 'mahdi',
          name: 'Dr. Mahdi Dawood',
          position: 'Director of the Union of Civil Society Organizations for Development',
          image: '/assets/logos/د. مهدي داوود.jpg',
          isHonorGuest: false
        },
        {
          id: 'kablan',
          name: 'Dr. Abdul Karim Kablan',
          position: 'Secretary General - General Union of Syrian Students',
          image: '/assets/logos/د. عبدالكريم قبلان.JPG',
          isHonorGuest: false
        },
        {
          id: 'ghassan',
          name: 'Journalist Ghassan Yassin',
          position: 'Moderator',
          image: '/assets/logos/المحاور الصحفي غسان ياسين.jpg',
          isHonorGuest: false
        },
        {
          id: 'musa_seminar',
          name: 'Journalist Musa Al-Omar',
          position: 'Journalist',
          image: '/assets/logos/الصحفي موسى العمر.jpeg',
          isHonorGuest: false
        },
        {
          id: 'aktaa',
          name: 'Prof. Mohammed Aktaa',
          position: 'Director General of the Civil Society Organizations Platform',
          image: '/assets/logos/أ. محمد أكتع.jpg',
          isHonorGuest: false
        }
      ]
    },
    tr: {
      title: "Hikayeyi Taşıyan Konuklar",
      subtitle: "'Zaferin Bir Yılı' etkinliği, devrimi yaşayan, yolunu takip eden ve belgeleme veya hizmet etme konusunda katkıda bulunan, her biri kendi konumundan bir dizi Suriyeli kişiliği ağırlıyor.",
      guests: [
        {
          id: 'saleh',
          name: 'Salih Hatib "Ebu Maher"',
          position: 'Şarkıcı/Okuyucu',
          image: '/assets/logos/منشد.png',
          isHonorGuest: true
        },
        {
          id: 'musa',
          name: 'Musa Al-Omar',
          position: 'Gazeteci',
          image: '/assets/logos/musa.jpg',
          isHonorGuest: true
        },
        {
          id: 'baraa',
          name: 'Baraa Al-Awad',
          position: 'Şarkıcı/Okuyucu',
          image: '/assets/logos/baraa.jpg',
          isHonorGuest: true
        },
        {
          id: 'halak',
          name: 'Abdul Nasser Halak',
          position: 'Şarkıcı/Okuyucu',
          image: '/assets/logos/halak.JPG',
          isHonorGuest: true
        }
      ],
      closingStatement: "Törenin bölümleri, hikayeyi yeniden anlatan bir deneyim sunmak için bir araya geliyor; kurtuluş anından Suriyeliler için ardından açılan yola kadar.",
      seminarTitle: "Seminer Konukları \"Diaspora Toplumunun Yeniden İnşadaki Rolü\"",
      seminarGuests: [
        {
          id: 'mahdi',
          name: 'Dr. Mahdi Dawood',
          position: 'Sivil Toplum Kuruluşları Kalkınma Birliği Müdürü',
          image: '/assets/logos/د. مهدي داوود.jpg',
          isHonorGuest: false
        },
        {
          id: 'kablan',
          name: 'Dr. Abdul Karim Kablan',
          position: 'Genel Sekreter - Suriye Öğrenci Genel Birliği',
          image: '/assets/logos/د. عبدالكريم قبلان.JPG',
          isHonorGuest: false
        },
        {
          id: 'ghassan',
          name: 'Gazeteci Ghassan Yassin',
          position: 'Moderatör',
          image: '/assets/logos/المحاور الصحفي غسان ياسين.jpg',
          isHonorGuest: false
        },
        {
          id: 'musa_seminar',
          name: 'Gazeteci Musa Al-Omar',
          position: 'Gazeteci',
          image: '/assets/logos/الصحفي موسى العمر.jpeg',
          isHonorGuest: false
        },
        {
          id: 'aktaa',
          name: 'Prof. Mohammed Aktaa',
          position: 'Sivil Toplum Kuruluşları Platformu Genel Müdürü',
          image: '/assets/logos/أ. محمد أكتع.jpg',
          isHonorGuest: false
        }
      ]
    }
  };

  const content = guestsContent?.[currentLanguage];

  return (
    <section id="guests" className="py-16 lg:py-24 bg-background">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="font-memorial text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4">
            {content?.title}
          </h2>
          <p className="font-body text-lg md:text-xl text-text-secondary max-w-3xl mx-auto">
            {content?.subtitle}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {content?.guests?.map((guest, index) => (
            <motion.div
              key={guest?.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`bg-card border rounded-lg overflow-hidden shadow-memorial hover:shadow-lg memorial-transition ${
                guest?.isHonorGuest 
                  ? 'border-primary/50 border-2 ring-2 ring-primary/20' 
                  : 'border-border'
              }`}
            >
              {/* Honor Guest Badge */}
              
              
              <div className="p-8">
                <div className="flex flex-col items-center text-center mb-4">
                  {/* Guest Photo */}
                  <div className="w-full h-64 md:h-72 rounded-lg overflow-hidden mb-6 border-2 border-border">
                    <Image
                      src={guest?.image || '/assets/images/no_image.png'}
                      alt={guest?.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  
                  {/* Guest Name */}
                  <h3 className="font-body text-2xl md:text-3xl font-semibold text-primary mb-3">
                    {guest?.name}
                  </h3>
                  
                  {/* Guest Position */}
                  <p className="font-body text-base md:text-lg text-text-secondary leading-relaxed">
                    {guest?.position}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Closing Statement */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-12 text-center"
        >
          <div className="bg-gradient-to-r from-primary/10 via-accent/10 to-success/10 border border-primary/20 rounded-lg p-6 md:p-8">
            <p className="font-body text-lg md:text-xl text-text-primary leading-relaxed font-medium">
              {content?.closingStatement}
            </p>
          </div>
        </motion.div>

        {/* Seminar Guests Section */}
        {content?.seminarTitle && content?.seminarGuests && (
          <>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.5 }}
              className="mt-16 pt-16 border-t border-border"
            >
              <h3 className="font-memorial text-2xl md:text-3xl lg:text-4xl font-bold text-primary mb-8 text-center">
                {content?.seminarTitle}
              </h3>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
              {content?.seminarGuests?.map((guest, index) => (
                <motion.div
                  key={guest?.id}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className={`bg-card border rounded-lg overflow-hidden shadow-memorial hover:shadow-lg memorial-transition ${
                    guest?.isHonorGuest 
                      ? 'border-primary/50 border-2 ring-2 ring-primary/20' 
                      : 'border-border'
                  }`}
                >
                  <div className="p-8">
                    <div className="flex flex-col items-center text-center mb-4">
                      {/* Guest Photo */}
                      <div className="w-full h-64 md:h-72 rounded-lg overflow-hidden mb-6 border-2 border-border">
                        <Image
                          src={guest?.image || '/assets/images/no_image.png'}
                          alt={guest?.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      
                      {/* Guest Name */}
                      <h3 className="font-body text-2xl md:text-3xl font-semibold text-primary mb-3">
                        {guest?.name}
                      </h3>
                      
                      {/* Guest Position */}
                      <p className="font-body text-base md:text-lg text-text-secondary leading-relaxed">
                        {guest?.position}
                      </p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default GuestsSection;

